import { PureComponent } from 'react'
import styled from 'glamorous'
import map from 'lodash/map'

import { $ } from 'utils'
import { InertialScrolling, ImagePure } from 'components'


const Container = styled.div({
  width: 185,
  marginLeft: 10,
  '&:first-child': {
    marginLeft: 0,
  }
})

const Header = styled.div({
  height: 35,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  fontWeight: 'bold',
  fontSize: 19,
})

const Avatar = styled.div({
  position: 'relative',
  marginBottom: 10
})

const PhotoContainer = styled.div({
  flex: 1,
  overflow: 'hidden',
  height: 50,
})

const PhotoInnerContainer = styled.div({
  display: 'flex',
  height: '100%',
  overflow: 'auto',
  cursor: 'pointer'
})

const MinPhoto = styled.div({
  marginRight: 5,
  '& img': {
    userDrag: 'none',
    WebkitUserDrag: 'none'
  }
})


export default class Original extends PureComponent {

  render = () => {
    const { source, type } = this.props
    const image = source.portrait
    return (
      $(Container,
        $(Header, `Original ${type}`),
        $(Avatar,
          $(ImagePure, {
            src: image,
            width: 185,
            height: 240
          })
        ),
        type === 'person' &&
          $(PhotoContainer,
            $(PhotoInnerContainer,
              $(InertialScrolling,
                map(source.descriptors, (val, key) =>
                  $(MinPhoto, { key },
                    $(ImagePure, {
                      src: val.portrait,
                      width: 38,
                      height: 50,
                    })
                  )
                )
              ),
            ),
          ),
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/panels/MatchingResults/Original.js